import type { IntervalJSON, ReportStructure } from '@highimpact-frontend/api-types';
import type { DashboardGridType } from '@highimpact/dashboard-types';
import { api_config, api_report } from '../../../api-commons';
import type { IReportModelService } from './IReportModelService';

class ReportModelService implements IReportModelService {
  getReportModelStructure(
    projectId: number,
    siteId: number,
    reportModelId: number,
    campaignId: number | null = null,
    intervals: IntervalJSON[] | null = null
  ): Promise<{
    report_structure: ReportStructure;
    layouts: DashboardGridType['layouts']['lg'];
  }> {
    let url: string;
    let params: Record<string, any>;
    if (intervals && intervals.length > 0) {
      url = `/report-models/${reportModelId}/structure/timeranges`;
      params = {
        report_model: {
          project_id: projectId,
          site_id: siteId,
          device_id: 0,
        },
        intervals: intervals && intervals.length > 0 ? intervals : []
      }
    } else if (campaignId !== null) {
      url = `/report-models/${reportModelId}/structure/campaigns/${campaignId}`;
      params = {
        project_id: projectId,
        site_id: siteId,
        device_id: 0,
      }
    } else {
      throw new Error('No intervals or campaignId provided');
    }
    return api_report
      .post(url, params)
      .then((response) => response.data);
  }

  getReportModelsBySite(siteId: number) {
    return api_config
      .get(`/site_report-models/${siteId}`)
      .then((response) => response.data);
  }

  getSiteReportModelByProject(projectId: number) {
    return api_config
      .get(`/site_report-model/${projectId}`)
      .then((response) => response.data);
  }

  getProjectReportModelByProject(projectId: number) {
    return api_config
      .get(`/project_report-model/${projectId}`)
      .then((response) => response.data);
  }

  processSiteReportModelAssociation(siteId: number, reportModelIds: number[]) {
    const queryParams = `${reportModelIds.length !== 0 &&
      reportModelIds.map((rm) => `&report_model_ids=${rm}`).join('')
      }`;

    return api_config
      .put(`/site_report-model/${siteId}&report_model_ids?${queryParams}`)
      .then((response) => response.data);
  }
}

const service = new ReportModelService();

export default service;
